<template>
  <footer class="layout-footer">
    <div class="def-w">
      <div class="quick-container">
        <ul class="menu-view">
          <li class="menu-item">
            公示公告
            <ul class="menu-router-list">
              <Link
                  v-for="item in infoTypeOpt"
                  :key="item[selectOpt.CODE]"
                  v-show="item[selectOpt.CODE] != 0"
                  :to="`/purchase/list?notice_type=${item[selectOpt.CODE]}`"
                  class="menu-router-link mt-10"
              >
                {{ item[selectOpt.LABEL] }}
              </Link>
            </ul>
          </li>

          <li class="menu-item">
            业务指南
            <ul class="menu-router-list">
              <Link
                  v-for="item in channel_ywzn[0].children"
                  :key="item.id"
                  :to="`/info/${item.id}`"
                  class="menu-router-link mt-10"
              >
                {{ item.channelName }}
              </Link>
            </ul>
          </li>
          <li class="menu-item">
            关于我们
            <ul class="menu-router-list">
              <Link
                  v-for="item in channel_gywm[0].children"
                  :key="item.id"
                  :to="`/info/${item.id}`"
                  class="menu-router-link mt-10"
              >
                {{ item.channelName }}
              </Link>
            </ul>
          </li>
        </ul>
        <div class="terrace-view">
          <div class="site-view">
            <div class="serve-info">
              <img
                  class="phone-icon"
                  src="@/assets/imgs/phone.png"
                  alt="icon"
              />
              <div class="serve-time">
                <div class="serve-time-item">
                  咨询服务热线：{{ site.zxfwrx }}
                </div>
                <div class="serve-time-item">
                  技术服务热线：{{ site.jsfwrx }}
                </div>
              </div>
            </div>
            <div class="site-info">
              <div class="mt-10">服务邮箱：{{ site.customerEmail }}</div>
              <div class="mt-10">服务时间：{{ site.weekday }}</div>
              <div class="mt-10">联系地址：{{ site.contactAddress }}</div>
            </div>
          </div>
          <div class="qrcode-view">
            <div class="qrcode-container">
              <div class="qrcode-info">
                <img :src="qrCode" alt="wechat"/>
              </div>
              <div class="qrcode-name mt-10">公众号二维码</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="line"/>
    <div class="def-w">
      <div class="filings-container">
        <div class="filings-line">
          {{ site.copyrightInformation }}
        </div>
        <div style="display: flex;justify-content: center">
          <a class="filings-line" style="color: #ffffff;" href="https://beian.miit.gov.cn/#/Integrated/index"
             target="_blank">{{ site.ICPRecordNumber }}</a>
          <a class="filings-line" style="color: #fff;margin-left: 10px;display: flex;align-items: center;"
             href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=45010802000562" target="_blank">
            <img style="width: 18px;height: 18px; margin-right: 5px;" src="@/assets/imgs/beian.png"/>
            桂公网安备45010802000562号
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Link from '@/layout/components/LayoutHead/HeadNav/Link.vue'
import {mapGetters} from 'vuex'
import {NOTICE_TYPE_OPTIONS, SELECT_OPTION_CONFIG} from '@/utils/constant'

export default {
  name: 'LayoutFooter',
  components: {
    Link,
  },
  data() {
    return {
      selectOpt: SELECT_OPTION_CONFIG,
      infoTypeOpt: NOTICE_TYPE_OPTIONS,
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(['allMenusTree', 'site', 'channel_ywzn', 'channel_gywm']),
    qrCode() {
      return this.site.baseUrl + this.site.gzhQrcode[0].url
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //this.getBusinessGuidMenu();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {},
}
</script>

<style lang="scss" scoped>
.layout-footer {
  padding: 30px 0 20px 0;
  background: #204268;

  .quick-container {
    display: flex;
    justify-content: space-between;
    color: #ffffff;

    .menu-view {
      width: 40%;
      display: flex;
      justify-content: space-between;

      .menu-item {
        font-size: 18px;
        font-weight: bold;
        color: #6681a0;

        .menu-router-list {
          .menu-router-link {
            display: block;
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
          }

          .menu-router-link:hover {
            color: #147ccd;
          }
        }
      }
    }

    .terrace-view {
      width: 60%;
      display: flex;
      justify-content: space-between;
      font-size: 16px;

      .site-view {
        width: 400px;
        margin-left: 15%;

        .serve-info {
          display: flex;
          justify-content: space-between;

          .phone-icon {
            width: 53px;
            height: 44px;
          }

          .serve-time {
            text-wrap: nowrap;
            width: 325px;
          }
        }
      }

      .qrcode-view {
        width: 150px;
        display: flex;
        justify-content: flex-end;

        .qrcode-container {
          text-align: center;

          .qrcode-info {
            width: 150px;
            height: 150px;
            padding: 10px;
            background: #ffffff;

            img {
              width: 100%;
            }
          }
        }
      }
    }
  }

  .line {
    width: 100%;
    height: 1px;
    background-color: #d8d8d8;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .filings-container {
    font-size: 16px;
    text-align: center;
    color: #ffffff;

    .filings-line {
      padding: 10px 0;
    }
  }
}
</style>
